import { merge } from 'lodash';
import { type AnyAction } from 'redux';
import { SET_APP_SETTINGS } from './app-settings-actions';

type State = Record<string, any>;

const getUpdatedAt = () => new Date().getTime();

export const appSettings = (state: State = {}, action: AnyAction): State => {
  switch (action.type) {
    case SET_APP_SETTINGS:
      return merge({}, state, action.payload, { updatedAt: getUpdatedAt() });
    default:
      return state;
  }
};
